import { render, staticRenderFns } from "./payDetails.vue?vue&type=template&id=d65ae25a&scoped=true"
import script from "./payDetails.vue?vue&type=script&lang=js"
export * from "./payDetails.vue?vue&type=script&lang=js"
import style0 from "./payDetails.vue?vue&type=style&index=0&id=d65ae25a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65ae25a",
  null
  
)

export default component.exports